import { TipoSexo } from '../shared/enums/tipo-sexo.enum';
import { CollaboratorAddress } from './colaborador';
import { AddressKyc } from './kyc';

export class ColaboradorCadastro {
    public linhaLote: number;
    constructor(
        public email: string,
        public nome: string,
        public sobrenome: string,
        public documento: string,
        public dataNascimento: any,
        public sexo: TipoSexo,
        public matricula: string,
        public nomeMae: string,
        public nomePai: string,
        // public celular: string,
        public celular: string,
        public centroCustoId: number,
        public centroCustoCod: string,
        public unidadeId: number,
        public unidadeCod: string,
        public departamentoId: number,
        public departamentoCod: string,
        public tipoColaborador?: number,
        public cedenteGuid?: string,
        public gestorGuid?: string,
        public cedenteId?: number,
        public apelido?: string,
        public endereco?: CollaboratorAddress,
        public colaboradorId?: number,
        public suspender?: boolean,
        public condutor?: boolean,
        public portador?: boolean,
        public suspensaoInicio?: any,
        public suspensaoFim?: any,
        public conductorId?: number,
        public cnh?: string,
        public cnhDataExpiracao?: any
    ) {
    }
}
